/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'plus': {
    width: 18,
    height: 18,
    viewBox: '0 0 18 18',
    data: '<path pid="0" d="M10.125 7.875h5.625v2.25h-5.625v5.625h-2.25v-5.625H2.25v-2.25h5.625V2.25h2.25z" _fill="#005BA5" fill-rule="evenodd"/>'
  }
})
